var map = {
	"./translation.en": [
		762,
		30,
		762
	],
	"./translation.en.ts": [
		762,
		30,
		762
	],
	"./translation.vn": [
		27,
		30,
		27
	],
	"./translation.vn.ts": [
		27,
		30,
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 270;
module.exports = webpackAsyncContext;